










































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { addLogistics, searchLogisticsInfo } from '@/utils/api';
interface options8 {
  value: string;
  label: string;
}
interface tabType {
  type: string;
  code: Number;
}
interface commitForm {
  code: string | null;
  companyCode: string | null;
  companyName: string | null;
  logisticsNumber: string | null;
  logisticsType: number;
  finalAftersaleType: number;
  returnType: number;
}
@Component
export default class logistics extends Vue {
  @Prop(String) nowCode: String;
  @Prop(Number) finalAftersaleType: Number;
  @Prop(Boolean) dialogFormVisible1: Boolean;
  @Watch('dialogFormVisible1', { immediate: true, deep: true })
  onWatchHandler(val) {
    if (val) {
      this.isClick = this.finalAftersaleType;
      // integer($int64)
      // 退货类型：仅售后服务类型为退货时使用，0为默认，1退货退款，2仅退款
      this.searchLogisticsInfo();
      // console.log(this.finalAftersaleType);
    }
  }
  options8: Array<options8> = [
    {
      value: '选项1',
      label: '黄金糕'
    },
    {
      value: '选项2',
      label: '双皮奶'
    },
    {
      value: '选项3',
      label: '蚵仔煎'
    },
    {
      value: '选项4',
      label: '龙须面'
    },
    {
      value: '选项5',
      label: '北京烤鸭'
    }
  ];
  isClick: Number = 1;
  tabType: Array<tabType> = [
    { type: '维修', code: 1 },
    { type: '换货', code: 2 },
    { type: '退货', code: 3 }
  ];
  commitForm: commitForm = {
    code: null,
    companyCode: null,
    companyName: null,
    logisticsNumber: null,
    logisticsType: 2,
    finalAftersaleType: null,
    returnType: 1
  };
  typeClick(item) {
    this.isClick = item.code;
  }
  mounted() {
    //  code	string
    // 售后单code
    // companyCode	string
    // 物流公司code
    // companyName	string
    // 物流公司名称
    // logisticsNumber	string
    // 物流运单编号
    // logisticsType	integer($int32)
    // 物流信息类型：1 采购商退货物流 2 供应商维修/换货后发货物流
  }
  // 新增物流信息
  addLogistics(commitForm) {
    addLogistics(commitForm)
      .then(res => {
        if (res) {
          // 通知父组件，重新请求列表数据
          this.$emit('toCompleteDelivery', 'ture');
          this.commitForm = {
            code: null,
            companyCode: null,
            companyName: null,
            logisticsNumber: null,
            logisticsType: 2,
            finalAftersaleType: null,
            returnType: 1
          };
        }
      })
      .catch(err => {
        console.log(err);
        this.$message.error(err);
          this.commitForm = {
            code: null,
            companyCode: null,
            companyName: null,
            logisticsNumber: null,
            logisticsType: 2,
            finalAftersaleType: null,
            returnType: 1
          };
      });
  }
  // 查询物流公司
  searchLogisticsInfo() {
    searchLogisticsInfo()
      .then(res => {
        this.options8 = res;
      })
      .catch(err => {
        console.log(err);
        this.$message.error(err);
      });
  }
  saveFrom() {
    let commitForm = null;
    if (this.isClick == 3) {
      commitForm = {
        code: this.nowCode,
        finalAftersaleType: this.isClick,
        returnType: 1
      };
    } else {
      commitForm = {
        ...this.commitForm,
        code: this.nowCode,
        finalAftersaleType: this.isClick,
        companyName: this.$refs['getCompanyName']['$children'][0].nativeInputValue
      };
    }
    console.log(commitForm);
    for (const key in commitForm) {
      if (!commitForm[key]) {
        this.$message.error('物流信息不全');
        return false;
      }
    }
    this.addLogistics(commitForm);
    this.$parent.$parent['dialogFormVisible1'] = false;
  }
  cancelForm() {
    this.$parent.$parent['dialogFormVisible1'] = false;
  }
}
